function getUpsell() {

  // Configuration
  const DEBUG = false;

  // Fonction pour récupérer les items du panier
  async function fetchCartItems() {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    return cart.items;
  }

  // Fonction pour récupérer les produits complémentaires d'un produit
  async function fetchComplementaryProducts(productId) {
    const url = window.Shopify.routes.root + `recommendations/products.json?product_id=${productId}&limit=10&intent=complementary`;
    const res = await fetch(url);
    const data = await res.json();
    return data.products || [];
  }

  // Fonction principale
  async function mainComplementaryDrawer() {
    try {
      // Récupération des items du panier
      const cartItems = await fetchCartItems();

      if (cartItems.length === 0) {
        return;
      }

      // Collecter les IDs des produits déjà dans le panier (pour ne pas les recommander)
      const cartProductIds = new Set(cartItems.map(item => item.product_id));

      // Récupérer les produits complémentaires pour chaque produit du panier
      const complementaryPromises = cartItems.map(item => fetchComplementaryProducts(item.product_id));
      const complementaryResults = await Promise.all(complementaryPromises);

      // Fusionner les produits complémentaires avec comptage de fréquence
      const productMap = new Map(); // id -> { product, frequency, firstPosition }
      let globalPosition = 0;

      for (const products of complementaryResults) {
        for (const product of products) {
          // Exclure les produits déjà dans le panier
          if (cartProductIds.has(product.id)) {
            continue;
          }

          if (productMap.has(product.id)) {
            // Produit déjà vu : incrémenter la fréquence
            productMap.get(product.id).frequency++;
          } else {
            // Nouveau produit : enregistrer avec sa position d'apparition
            productMap.set(product.id, {
              product,
              frequency: 1,
              firstPosition: globalPosition++
            });
          }
        }
      }

      // Trier par fréquence (décroissante) puis par position Shopify (croissante)
      // et filtrer les produits sans stock
      const sortedProducts = Array.from(productMap.values())
        .filter(item => item.product.available && item.product.variants.some(v => v.available))
        .sort((a, b) => {
          if (b.frequency !== a.frequency) {
            return b.frequency - a.frequency; // Plus recommandé en premier
          }
          return a.firstPosition - b.firstPosition; // Position Shopify en cas d'égalité
        })
        .map(item => item.product);

      // Debug : afficher la liste complète avant troncature
      if (DEBUG) {
        console.log('[Upsell ELX] Produits complémentaires (avant troncature à 6) :', sortedProducts.map(p => ({
          id: p.id,
          title: p.title,
          available: p.available,
          variants_available: p.variants.filter(v => v.available).length + '/' + p.variants.length
        })));
      }

      // Afficher jusqu'à 6 produits complémentaires
      const maxProducts = Math.min(sortedProducts.length, 6);
      for (let i = 0; i < maxProducts; i++) {
        renderComplementaryProductCard(sortedProducts[i]);
      }

    } catch (error) {
      console.error("Erreur lors de la récupération des produits complémentaires :", error);
    }
  }

  mainComplementaryDrawer();
}

// Fabrique une carte produit complémentaire et l'ajoute au DOM
function renderComplementaryProductCard(product) {
  const grid = document.querySelector(`#upsell_drawer_container`);

  // Recherche de la première variante disponible
  const availableVariant = product.variants.find(variant => variant.available === true);

  // Création de la carte produit uniquement si une variante est disponible
  if (availableVariant) {
    const productDiv = document.createElement('div');
    productDiv.classList.add('upsell_item');

    // Formatage du prix (l'API retourne le prix en centimes)
    const formattedPrice = (product.price / 100).toFixed(2).replace('.', ',');

    productDiv.innerHTML = `
      <img src="${product.featured_image}&width=120" alt="${product.title}" class="upsell_card_image">
      <div class="upsell_card_content">
        <div class="upsell_card_title"><a href="${product.url}">${product.title}</a></div>
        <div class="upsell_card_bottom">
          <div class="upsell_card_price">${formattedPrice} €</div>
          <product-form>
            <form action="/cart/add" method="post" class="upsell_card_form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="id" value="${availableVariant.id}">
              <button type="submit" class="upsell_card_button">Ajouter</button>
            </form>
          </product-form>
        </div>
      </div>
    `;

    grid.appendChild(productDiv);
  }
}

// Lancement du script
getUpsell();
